module.exports = __webpack_public_path__ + "static/media/Auckland.5100b111.jpg";